module.exports = __webpack_public_path__ + "static/media/book-mock-es.36eb3778.png";